import { jsx as e, jsxs as n } from "react/jsx-runtime";
function r(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 16 16", width: "1em", ...l, children: /* @__PURE__ */ n("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ e("path", { d: "M16 16H0V0h16z" }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M7.306 12.776L.616 6.333A.822.822 0 01.593 5.17l.022-.022a.89.89 0 011.231 0L8 11.074l6.154-5.926a.888.888 0 011.23 0 .822.822 0 01.023 1.163l-.022.022-6.691 6.443a1 1 0 01-1.388 0z",
        fill: "currentColor"
      }
    )
  ] }) });
}
export {
  r as default
};
